import { StyleSheet, Platform } from 'react-native';
import { COLORS } from '../constants/theme';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    padding: 0,
  },
  headerContainer: {
    backgroundColor: COLORS.primary,
    paddingTop: Platform.OS === 'ios' ? 50 : 20,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
  },
  headerContainerDesktop: {
    backgroundColor: 'transparent',
    paddingTop: 16,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingVertical: 16,
  },
  headerDesktop: {
    paddingVertical: 20,
  },
  headerContent: {
    flex: 1,
    alignItems: 'center',
  },
  headerLeft: {
    flex: 1,
    alignItems: 'flex-start',
  },
  backButton: {
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  backIcon: {
    fontSize: 40,
    color: '#FFFFFF',
    fontWeight: '300',
    textAlign: 'center',
    lineHeight: 40,
    marginTop: -2,
  },
  backIconDesktop: {
    color: '#6B7280',
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: '#FFFFFF',
    fontFamily: 'Montserrat_600SemiBold',
  },
  headerTitleDesktop: {
    fontSize: 24,
    color: '#1F2937',
  },
  dateRangeContainer: {
    paddingHorizontal: 20,
    paddingBottom: 16,
  },
  dateRangeText: {
    fontSize: 14,
    color: '#FFFFFF',
    opacity: 0.95,
    fontFamily: 'Montserrat_400Regular',
  },
  dateRangeTextInline: {
    fontSize: 14,
    color: '#FFFFFF',
    opacity: 0.95,
    fontFamily: 'Montserrat_400Regular',
    marginTop: 4,
  },
  dateRangeTextInlineDesktop: {
    color: '#6B7280',
    opacity: 1,
  },
  searchButton: {
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  searchIcon: {
    fontSize: 20,
    color: '#FFFFFF',
  },
  searchIconDesktop: {
    color: '#6B7280',
  },
  headerSpacer: {
    width: 40,
  },
  content: {
    flex: 1,
    padding: 20,
    backgroundColor: '#FFFFFF',
    maxWidth: 1200,
    alignSelf: 'center',
    width: '100%',
  },
  weekSelector: {
    flexDirection: 'row',
    backgroundColor: '#F3F4F6',
    width: '60%',
    alignSelf: 'center',
    marginVertical: 15,
    borderRadius: 20,
    padding: 3,
  },
  weekButton: {
    flex: 1,
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 16,
    alignItems: 'center',
  },
  weekButtonActive: {
    backgroundColor: '#FFFFFF',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.15,
    shadowRadius: 4,
    elevation: 3,
  },
  weekButtonInactive: {
    backgroundColor: 'transparent',
  },
  weekButtonText: {
    fontSize: 13,
  },
  weekButtonTextActive: {
    color: '#1F2937',
    fontFamily: 'Montserrat_600SemiBold',
  },
  weekButtonTextInactive: {
    color: '#606060',
    fontFamily: 'Montserrat_500Medium',
  },
  dashboardContainer: {
    marginBottom: 24,
    marginTop: 8,
    //width: '100%',
    alignItems: 'center',
  },
  dashboardWithCalendar: {
    flexDirection: 'column',
    gap: 24,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  categoriesTable: {
    width: '100%',
    maxWidth: 1200,
    alignSelf: 'center',
  },
  categoriesHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    flexWrap: 'wrap',
  },
  categoriesHeaderCell: {
    flex: 0,
    alignItems: 'center',
    minWidth: 180,
    maxWidth: 250,
  },
  categoriesHeaderText: {
    fontSize: 14,
    color: '#1F2937',
    fontFamily: 'Montserrat_600SemiBold',
    textAlign: 'center',
  },
  categoriesDataRow: {
    flexDirection: 'row',
    alignItems: 'stretch',
    gap: 8,
    marginTop: 12,
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  categoriesRowLabelCell: {
    width: 90,
    justifyContent: 'center',
    paddingLeft: 4,
  },
  categoriesRowLabelTitle: {
    fontSize: 12,
    color: '#6B7280',
    fontFamily: 'Montserrat_500Medium',
  },
  categoriesRowLabelSubtitle: {
    fontSize: 14,
    color: '#1F2937',
    fontFamily: 'Montserrat_600SemiBold',
    marginTop: 2,
  },
  categoriesCardCell: {
    flex: 0,
    minWidth: 180,
    maxWidth: 250,
  },
  categoriesCard: {
    minWidth: 0,
    width: '100%',
    maxWidth: '100%',
    minHeight: 110,
    padding: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  categoriesCardBody: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  categoriesCardSubtitle: {
    fontSize: 13,
    color: '#374151',
    fontFamily: 'Montserrat_500Medium',
    marginTop: 8,
    textAlign: 'center',
  },
  categoriesCardIconPosition: {
    position: 'absolute',
    top: 8,
    right: 8,
  },
  categoriesCardNumberContainer: {
    width: 56,
    height: 56,
    borderRadius: 28,
    borderWidth: 4,
    marginTop: 0,
  },
  categoriesCardNumber: {
    fontSize: 22,
  },
  dashboardBottomRow: {
    width: '100%',
    maxWidth: 1200,
    alignSelf: 'center',
    flexDirection: 'row',
    gap: 24,
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  /** Riesgo + calendario en una sola línea en desktop */
  dashboardBottomRowDesktop: {
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
  },
  dashboardBottomRowMobile: {
    flexDirection: 'column',
  },
  productsAtRiskSection: {
    width: '100%',
    maxWidth: 1200,
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'stretch',
    gap: 12,
    marginBottom: 24,
    alignSelf: 'center',
  },
  /** Tres cards compactas al lado del calendario (no ocupan todo el ancho) */
  productsAtRiskSectionDesktop: {
    width: 'auto',
    maxWidth: 410,
    flexWrap: 'nowrap',
    flexGrow: 0,
    flexShrink: 0,
    marginBottom: 0,
    gap: 10,
    alignSelf: 'center',
  },
  productsAtRiskMiniCardShell: {
    flexGrow: 1,
    flexBasis: 160,
    minWidth: 150,
    maxWidth: 220,
  },
  productsAtRiskMiniCardShellDesktop: {
    flexGrow: 0,
    flexShrink: 0,
    minWidth: 116,
    maxWidth: 130,
    flexBasis: 122,
  },
  productsAtRiskMiniCard: {
    borderRadius: 12,
    padding: 14,
    minHeight: 130,
    width: '100%',
    justifyContent: 'space-between',
  },
  productsAtRiskMiniCardCompact: {
    paddingVertical: 10,
    paddingHorizontal: 11,
    minHeight: 118,
    borderRadius: 11,
  },
  productsAtRiskMiniCardDesktop: {
    position: 'relative',
    justifyContent: 'center',
  },
  productsAtRiskMiniCardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 8,
    width: '100%',
    paddingRight: 36,
  },
  productsAtRiskMiniCardHeaderCompact: {
    marginBottom: 6,
    paddingRight: 32,
  },
  productsAtRiskMiniCardIconCompact: {
    width: 30,
    height: 30,
    borderRadius: 15,
  },
  productsAtRiskIconImageCompact: {
    width: 16,
    height: 16,
  },
  productsAtRiskNeutralTitleDesktopCompact: {
    fontSize: 12,
    lineHeight: 15,
  },
  riskTitleDesktopCompact: {
    fontSize: 13,
    lineHeight: 16,
  },
  productsAtRiskNeutralNumberDesktopCompact: {
    fontSize: 24,
    marginTop: 2,
  },
  riskNumberDesktopCompact: {
    fontSize: 26,
  },
  productsAtRiskMiniCardIconPosition: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  productsAtRiskNeutralTitle: {
    fontSize: 14,
    fontFamily: 'Montserrat_500Medium',
    color: '#374151',
    textAlign: 'left',
    flex: 1,
  },
  productsAtRiskNeutralNumber: {
    fontSize: 28,
    fontFamily: 'Montserrat_600SemiBold',
    color: '#1F2937',
    textAlign: 'center',
    alignSelf: 'center',
    marginTop: 4,
  },
  productsAtRiskNeutralNumberUnderlined: {
    textDecorationLine: 'underline',
    textDecorationColor: '#1F2937',
  },
  productsAtRiskIconImageNeutral: {
    tintColor: '#374151',
  },
  riskCardLowStrike: {
    backgroundColor: '#FF7D80',
  },
  productsAtRiskCard: {
    borderRadius: 12,
    padding: 18,
    minHeight: 170,
    minWidth: 200,
    maxWidth: 250,
  },
  productsAtRiskHeaderRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 14,
    width: '100%',
  },
  productsAtRiskIcon: {
    backgroundColor: 'rgba(255, 255, 255, 0.25)',
  },
  productsAtRiskIconImage: {
    width: 18,
    height: 18,
    resizeMode: 'contain',
  },
  productsAtRiskMetricsLabelsRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: 6,
  },
  productsAtRiskMetricsNumbersRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    marginTop: 6,
  },
  productsAtRiskMetricsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    marginTop: 8,
  },
  productsAtRiskMetricCell: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  productsAtRiskMetricTouchable: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 6,
  },
  dashboardCardsContainer: {
    flex: 1,
    gap: 12,
    maxWidth: 800,
    alignItems: 'center',
  },
  dashboardRow: {
    flexDirection: 'row',
    gap: 16,
    marginBottom: 16,
    justifyContent: 'center',
    width: '100%',
  },
  calendarContainer: {
    marginTop: 0,
    alignItems: 'center',
    width: 320,
    flexShrink: 0,
    flexGrow: 0,
    marginBottom: 24,
  },
  weekSelectorSection: {
    width: '100%',
    marginBottom: 8,
  },
  clearFiltersButton: {
    alignSelf: 'center',
    marginTop: 12,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 8,
    backgroundColor: '#F3F4F6',
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  clearFiltersButtonText: {
    fontSize: 14,
    color: '#6B7280',
    fontFamily: 'Montserrat_500Medium',
  },
  dashboardCard: {
    flex: 1,
    borderRadius: 12,
    padding: 16,
    minHeight: 140,
    justifyContent: 'space-between',
    minWidth: 140,
    maxWidth: 170,
  },
  dashboardCardDesktop: {
    position: 'relative',
    justifyContent: 'center',
  },
  cardIconTopRight: {
    position: 'absolute',
    top: 8,
    right: 8,
  },
  cardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
    marginTop: 0,
    width: '100%',
  },
  riskTitleContainer: {
    alignItems: 'flex-start',
  },
  // Mobile colors (originales)
  expiryCard: {
    backgroundColor: '#D3EAED',
  },
  couponCard: {
    backgroundColor: '#D3EAED',
  },
  autocallCard: {
    backgroundColor: '#D3EAED',
  },
  // Desktop colors
  expiryCardDesktop: {
    backgroundColor: '#E5F0F2',
  },
  couponCardDesktop: {
    backgroundColor: '#E5F0F2',
  },
  couponBoxHighlight: {
    backgroundColor: '#b8c2c3',
  },
  couponBoxHighlightDesktop: {
    backgroundColor: '#b8c2c3',
  },
  autocallCardDesktop: {
    backgroundColor: '#E5F0F2',
  },
  cardIcon: {
    width: 32,
    height: 32,
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardIconImage: {
    width: 20,
    height: 20,
    resizeMode: 'contain',
  },
  cardIconDesktop: {
    width: 48,
    height: 48,
    borderRadius: 24,
  },
  cardIconImageDesktop: {
    width: 30,
    height: 30,
  },
  cardNumber: {
    fontSize: 30,
    fontFamily: 'Montserrat_600SemiBold',
    color: '#1F2937',
  },
  cardNumberContainer: {
    width: 70,
    height: 70,
    borderRadius: 35,
    borderWidth: 5,
    borderColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    marginTop: 6,
  },
  cardNumberContainerDesktop: {
    marginTop: 0,
  },
  cardLabel: {
    fontSize: 15,
    fontFamily: 'Montserrat_500Medium',
    color: '#374151',
    textAlign: 'left',
  },
  riskTitle: {
    fontSize: 15,
    fontFamily: 'Montserrat_500Medium',
    color: '#FFFFFF',
    textAlign: 'left',
  },
  riskLabelsRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginTop: 8,
    marginBottom: 4,
  },
  riskLabel: {
    fontSize: 13,
    fontFamily: 'Montserrat_500Medium',
    color: '#FFFFFF',
    textAlign: 'center',
  },
  riskNumbersRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    marginTop: 4,
  },
  riskNumber: {
    fontSize: 28,
    fontFamily: 'Montserrat_600SemiBold',
    color: '#FFFFFF',
    textAlign: 'center',
    minWidth: 35,
  },
  riskNumberUnderlined: {
    textDecorationLine: 'underline',
    textDecorationColor: '#FFFFFF',
  },
  riskSeparator: {
    fontSize: 28,
    fontFamily: 'Montserrat_500Medium',
    color: '#FFFFFF',
    marginHorizontal: 10,
    textAlign: 'center',
  },
  riskSubLabel: {
    fontSize: 10,
    fontFamily: 'Montserrat_500Medium',
    color: '#fff',
    textAlign: 'center',
  },
  cardBodyMobile: {
    alignItems: 'center',
  },
  cardBodyDesktop: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
  },
  cardLabelDesktop: {
    fontSize: 15,
    fontFamily: 'Montserrat_500Medium',
    color: '#374151',
    textAlign: 'left',
  },
  periodSelector: {
    flexDirection: 'row',
    backgroundColor: '#F3F4F6',
    width: '80%',
    alignSelf: 'center',
    marginVertical: 15,
    borderRadius: 20,
    padding: 3,
  },
  periodButton: {
    flex: 1,
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 16,
    alignItems: 'center',
  },
  periodButtonActive: {
    backgroundColor: '#FFFFFF',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.15,
    shadowRadius: 4,
    elevation: 3,
  },
  periodButtonInactive: {
    backgroundColor: 'transparent',
  },
  periodButtonText: {
    fontSize: 13,
    textAlign: 'center',
  },
  periodButtonTextActive: {
    color: '#1F2937',
    fontFamily: 'Montserrat_600SemiBold',
  },
  periodButtonTextInactive: {
    color: '#606060',
    fontFamily: 'Montserrat_500Medium',
  },
  eventsContainer: {
    marginTop: 8,
  },
  eventsRow: {
    flexDirection: 'row',
    gap: 12,
    marginBottom: 12,
  },
  eventItemWrapper: {
    flex: 1,
    minWidth: 0,
  },
  eventCard: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 3,
    height: '100%',
  },
  eventCardTablet: {
    minHeight: 180,
    padding: 20,
  },
  eventCardHeader: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 12,
  },
  eventCardContent: {
    marginBottom: 12,
  },
  eventCardFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginTop: 4,
  },
  eventLeftSection: {
    flex: 1,
  },
  eventAmountContainer: {
    alignItems: 'flex-end',
  },
  eventIsin: {
    fontSize: 18,
    fontFamily: 'Montserrat_500Medium',
    color: '#1f2937',
    marginBottom: 6,
  },
  eventProductName: {
    fontSize: 15,
    fontFamily: 'Montserrat_400Regular',
    color: '#4b5563',
    lineHeight: 22,
  },
  eventDate: {
    fontSize: 12,
    fontWeight: '400',
    color: '#9ca3af',
  },
  eventTypeLabel: {
    fontSize: 18,
    fontFamily: 'Montserrat_600SemiBold',
    color: '#00506E',
  },
  eventAmount: {
    fontSize: 20,
    fontFamily: 'Montserrat_700Bold',
    color: '#1f2937',
    marginBottom: 2,
    textAlign: 'right',
  },
  eventCurrency: {
    fontSize: 13,
    fontFamily: 'Montserrat_500Medium',
    color: '#6b7280',
    textAlign: 'right',
  },
  noEventsContainer: {
    alignItems: 'center',
    paddingVertical: 40,
  },
  noEventsText: {
    fontSize: 16,
    color: '#6b7280',
    marginTop: 12,
  },
  loadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.35)',
  },
  loadingText: {
    fontSize: 16,
    color: '#6b7280',
    marginTop: 12,
  },
  errorContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  errorText: {
    fontSize: 16,
    color: '#ef4444',
    textAlign: 'center',
    marginBottom: 20,
  },
  retryButton: {
    backgroundColor: '#0891b2',
    paddingHorizontal: 24,
    paddingVertical: 12,
    borderRadius: 8,
  },
  retryButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
  },
  sectionTitle: {
    fontSize: 18,
    fontFamily: 'Montserrat_600SemiBold',
    color: '#1F2937',
    marginTop: 24,
    marginBottom: 16,
    paddingHorizontal: 4,
    textAlign: 'center',
    width: '100%',
    maxWidth: 800,
    alignSelf: 'center',
  },
  sideTabsContainer: {
    width: 180,
    paddingVertical: 8,
    paddingRight: 8,
  },
  sideTabsContainerMobile: {
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  tabButton: {
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderRadius: 8,
    marginBottom: 6,
    marginRight: 6,
    backgroundColor: '#F3F4F6',
  },
  tabButtonActive: {
    backgroundColor: '#E0F2FE',
  },
  tabButtonText: {
    fontSize: 14,
    color: '#6B7280',
    fontFamily: 'Montserrat_500Medium',
  },
  tabButtonTextActive: {
    color: '#00506E',
    fontFamily: 'Montserrat_600SemiBold',
  },
  dashboardWithTabs: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    width: '100%',
  },
  dashboardWithTabsMobile: {
    flexDirection: 'column',
    width: '100%',
  },
});

export default styles;


